import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
// Import Model
import { QuotaionItemlistModel } from "../../../../model/jubili/quotationitem/quotation";
import { SortCompanyModel } from "../../../../model/jubili/company-manage/company-sort";
// Import Enum
import { SortType } from "../../../../enum/jubili/company-manage/sort-type";
import { QuotationStatus } from "../../../../enum/jubili/quotationitem/quotation-status";

@Component({
    selector: "bo-jub-quotation-table",
    templateUrl: "./quotation-table.component.html",
    styleUrls: ["./quotation-table.component.scss"]
})

export class QuotationTableComponent implements OnInit {
    constructor(
        public router: Router
    ) { }

    private _data = new BehaviorSubject<Array<QuotaionItemlistModel>>(new Array<QuotaionItemlistModel>());
    @Output() sortOutput = new EventEmitter<SortCompanyModel>();
    @Input()
    set getQuotationItemDataIndex(value) {
        this._data.next(value);
    }
    get getQuotationItemDataIndex(): Array<QuotaionItemlistModel> {
        return this._data.getValue();
    }
    // using for sort
    sortData: SortCompanyModel = new SortCompanyModel();
    sortQoItemId: boolean = false;
    sortQoItemCode: boolean = false;
    sortDocDate: boolean = false;
    sortItemname: boolean = false;
    sortQuantity: boolean = false;
    sortUnit: boolean = false;
    sortUnitPrice: boolean = false;
    sortAmount: boolean = false;
    sortCompanyname: boolean = false;
    sortProspectname: boolean = false;
    sortProjectname: boolean = false;
    sortCategory: boolean = false;
    sortQostatus: boolean = false;
    status: string = "";

    ngOnInit(): void {
        this._data
            .subscribe(x => {
                console.log(this._data);
            });
    }

    // When click header call function
    sortStatus(event: any, status: boolean): void {
        this.sortQoItemId = false;
        this.sortQoItemCode = false;
        this.sortDocDate = false;
        this.sortItemname = false;
        this.sortQuantity = false;
        this.sortUnit = false;
        this.sortUnitPrice = false;
        this.sortAmount = false;
        this.sortCompanyname = false;
        this.sortProspectname = false;
        this.sortProjectname = false;
        this.sortCategory = false;
        this.sortQostatus = false;
        if (status) { // sort to DESC
            this.sortQoItemId = false;
            this.sortQoItemCode = false;
            this.sortDocDate = false;
            this.sortItemname = false;
            this.sortQuantity = false;
            this.sortUnit = false;
            this.sortUnitPrice = false;
            this.sortAmount = false;
            this.sortCompanyname = false;
            this.sortProspectname = false;
            this.sortProjectname = false;
            this.sortCategory = false;
            this.sortQostatus = false;

            this.sortData.sortCol = event;
            this.sortData.sortType = SortType.DESC;
            this.sortOutput.emit(this.sortData);
        } else {// sort to ASC
            if (event === "qoItemId") {
                this.sortQoItemId = true;
                this.sortData.sortCol = "qoItemId";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "qoItemCode") {
                this.sortQoItemCode = true;
                this.sortData.sortCol = "qoItemCode";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "docDate") {
                this.sortDocDate = true;
                this.sortData.sortCol = "docDate";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "qoItemname") {
                this.sortItemname = true;
                this.sortData.sortCol = "qoItemname";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "quantity") {
                this.sortQuantity = true;
                this.sortData.sortCol = "quantity";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "unit") {
                this.sortUnit = true;
                this.sortData.sortCol = "unit";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "unitPrice") {
                this.sortUnitPrice = true;
                this.sortData.sortCol = "unitPrice";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "amount") {
                this.sortAmount = true;
                this.sortData.sortCol = "amount";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "companyName") {
                this.sortCompanyname = true;
                this.sortData.sortCol = "companyName";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "prospectName") {
                this.sortProspectname = true;
                this.sortData.sortCol = "prospectName";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "projectName") {
                this.sortProjectname = true;
                this.sortData.sortCol = "projectName";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "category") {
                this.sortCategory = true;
                this.sortData.sortCol = "category";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "qostatus") {
                this.sortQostatus = true;
                this.sortData.sortCol = "qostatus";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            }
        }
    }

    checkQuotationstatus(status: number): string {
        switch (status) {
            case QuotationStatus.Win: {
                this.status = "Win";
                break;
            }
            case QuotationStatus.Followup: {
                this.status = "Followup";
                break;
            }
            case QuotationStatus.Lost: {
                this.status = "Lost";
                break;
            }
            case QuotationStatus.Revised: {
                this.status = "Revised";
                break;
            }
            case QuotationStatus.Trashed: {
                this.status = "Trashed";
                break;
            }
            case QuotationStatus.WaitingForApprove: {
                this.status = "Waiting";
                break;
            }
            default: {
                this.status = "";
                break;
            }
        }

        return this.status;
    }
}
